import Home from './home';
import RedPacket from './red-packet';

export default {
  Home,
  RedPacket,
};
